export default function FooterSection() {
  return (
    <footer className="py-3">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between text-[11px] text-gray-400">
        <span>© {new Date().getFullYear()} Botervue</span>

        <div className="flex gap-3">
          <span className="hover:text-gray-600 cursor-pointer">Privacy</span>
          <span className="hover:text-gray-600 cursor-pointer">Terms</span>
          <span className="hover:text-gray-600 cursor-pointer">Help</span>
        </div>
      </div>
    </footer>
  );
}
